<template>
  <!-- 通用设置 -->
  <div>
    <SpGlobalAlertWarning
      info="修改设置前请先确认"
      class-name="custom_alert"
    />

    <SpCardContent :title="`通用设置`">
      <el-form
        ref="ruleForm"
        :rules="ruleForm"
        :model="form"
        label-width="200px"
      >
        <el-form-item
          label="离职客户自动分配："
          prop="leave_auto_assign"
        >
          <el-switch v-model="form.leave_auto_assign" />
          <div class="tips">
            设置说明：<br>
            【开启状态】导购离职后，其名下的客户自动平均分配给当前门店下其他导购，并与分配的客户绑定关系。<br>
            【关闭状态】导购离职后，店长角色需手动将离职导购名下的客户分配给其门店下其他指定导购或自己，并与分配的客户绑定关系。
          </div>
        </el-form-item>

        <el-form-item
          label="佣金确认在订单完成后："
          prop="order_done_confirm_commission"
        >
          <div class="view-flex">
            <el-input
              v-model.number="form.order_done_confirm_commission"
              class="input-s input-set"
            />
            <span>天</span>
          </div>
          <div class="tips">
            设置说明：<br>
            设置确认结算佣金的时间节点，订单的佣金确认时间节点，以订单生成时所设置的时间周期计算后的具体时间点为记录点
          </div>
        </el-form-item>
      </el-form>
    </SpCardContent>

    <SpGlobalFooter>
      <el-button
        type="primary"
        :loading="loading"
        @click="onSubmit('ruleForm')"
      >
        保存设置
      </el-button>
    </SpGlobalFooter>
  </div>
</template>

<script>
import { getGeneral, setGeneral } from '@/api/setting/generalSettings'
export default {
  data () {
    var checkDays = (rule, value, callback) => {
      if (!value && value !== 0) {
        return callback(new Error('天数不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (value < 0) {
            callback(new Error('设置的天数必须大于等于0'))
          } else {
            callback()
          }
        }
      }, 500)
    }

    return {
      loading: false,
      form: {
        leave_auto_assign: false, // 离职客户自动分配是否开启
        order_done_confirm_commission: 7 //佣金确认在订单完成天数，默认7天
      },
      ruleForm: {
        //表单验证规则
        order_done_confirm_commission: [{ validator: checkDays, trigger: 'blur' }]
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    onSubmit (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true
          const data = await setGeneral(this.form)
          if (data) {
            this.loading = false
            this.$message({ type: 'success', message: '保存成功' })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async init () {
      const data = await getGeneral()
      if (data) {
        this.form = data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wechat-top {
  margin-bottom: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  font-size: 28px;
  color: #606266;
}

.card {
  border: none;
  border-radius: 0;
}
.warning {
  padding: 0 16px;
  height: 45px;
  box-sizing: border-box;
  background-color: #fff;
  border-left: 10px solid #1480e3;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  font-size: 16px;
  color: #606266;
}

.input-set {
  margin-right: 8px;
  width: 200px;
}
.title-item {
  margin-right: 8px;
}
.custom_alert {
  margin-bottom: 20px;
}
</style>
